var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c("div", { staticClass: "w-full md:w-3/4 md:pr-20" }, [
      !_vm.saving
        ? _c("form", { attrs: { method: "POST" } }, [
            _c("div", { staticClass: "mb-12" }, [
              _c("label", { ref: "title", attrs: { for: "title" } }, [
                _vm._v("\n                    Resource Title "),
                _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                _vm._v(" "),
                _c("div", { staticClass: "text-sm font-sans-book" }, [
                  _vm._v("50 character maximum (including spaces)."),
                ]),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:50",
                    expression: "'required|max:50'",
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.title,
                    expression: "form.title",
                  },
                ],
                attrs: { id: "title", type: "text", name: "title" },
                domProps: { value: _vm.form.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form, "title", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
                [_vm._v("Character count: " + _vm._s(_vm.characterCount))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("title"),
                      expression: "errors.has('title')",
                    },
                  ],
                  staticClass: "error text-error-red text-lg",
                },
                [_vm._v(_vm._s(_vm.errors.first("title")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-12" }, [
              !_vm.saving
                ? _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.saveResource.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Save")]
                  )
                : _c("span", [_vm._v("Saving...")]),
            ]),
          ])
        : _c("div", { staticClass: "text-2xl text-center mb-4" }, [
            _vm._v("Saving Resource..."),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }